import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'
import { cloneDeep } from 'lodash'

// 引入路由
import monitorRoutes from '@/router/business/monitor'
import riskRoutes from '@/router/business/risk'
import performanceRoutes from '@/router/performance/index'

/**
 * 设置风险治理的路由，增加查询统计权限
 * @returns {*}
 */
function setRiskRoutesRight() {
  const loop = list => {
    return list
      .map(route => {
        if (route.children && route.children.length) {
          route.children = loop(route.children)
        }
        if (
          route.roles.includes(platformFunctionModuleDict.RISK_GOVERNMENT.right)
        ) {
          route.roles.push(platformFunctionModuleDict.QUERY_STATS.right)
        }
        return route
      })
      .filter(v => v)
  }

  return loop(cloneDeep([riskRoutes]))[0]
}

/**
 * 设置采购履约的路由，去除代理机构和供应商的平台路由，并增加查询统计权限
 */
function setPerformanceRoutesRight() {
  const loop = list => {
    return list
      .map(route => {
        if (route.children && route.children.length) {
          route.children = loop(route.children)
        }
        if (
          route.applicableCompanyIdentities.includes(
            workbenchServiceDict.PURCHASER.value
          )
        ) {
          route.applicableCompanyIdentities = [
            workbenchServiceDict.PURCHASER.value
          ]
          route.roles = [
            platformFunctionModuleDict.PURCHASER.right,
            platformFunctionModuleDict.QUERY_STATS.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ]
          return route
        } else {
          return undefined
        }
      })
      .filter(v => v)
  }

  return loop(cloneDeep(performanceRoutes))[0]
}

/**
 * 采购监管，原云采购的项目统计
 */
export default {
  path: 'monitor',
  type: menuTypeDict.DIRECTORY.value,
  meta: {
    title: '采购监管',
    layout: 'DefaultLayout'
  },
  applicableCompanyTypes: [
    { companyType: companyTypeDict.ENTERPRISE.value },
    { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
  ],
  platformAlias: [],
  applicableCompanyIdentities: [
    workbenchServiceDict.PURCHASER.value,
    workbenchServiceDict.AGENCY.value
  ],
  roles: [
    platformFunctionModuleDict.PURCHASER.right,
    platformFunctionModuleDict.QUERY_STATS.right,
    platformFunctionModuleDict.RISK_GOVERNMENT.right,
    platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
  ],
  superviseInstitutions: [],

  children: [
    ...monitorRoutes.children[0].children
      .map(route => {
        if (
          [
            '项目统计',
            '品目价格分析',
            '供应商分析',
            '代理机构分析',
            '协同项目分析',
            '自动化报告'
          ].includes(route.meta.title)
        ) {
          return route
        }
      })
      .filter(v => v),

    // 风险治理
    setRiskRoutesRight(),
    // 采购履约
    setPerformanceRoutesRight(),

    ...monitorRoutes.children
      .map(route => {
        if (
          ['采购项目查询', '代理项目查询', '标书费查询'].includes(
            route.meta.title
          )
        ) {
          return route
        }
      })
      .filter(v => v)
  ]
}
